import XLSX from 'xlsx';
import dayjs from "dayjs";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";

export const headerWidthSizes = {
    tiny: 5,
    short: 10,
    normal: 15,
    long: 30,
}

export const cellDataTypes = {
    text: `s`,
    number: `n`,
    // date: `d`
}

export function useReportExcelExport({
    routeType
}) {

    const { promptMessage } = useSystemPrompt()

    const getColsDefault = ({ headerConfigs }) => {

        // Function to convert column letter (A, B, C) to index (0, 1, 2)
        const getColumnIndex = (colLetter) => colLetter.charCodeAt(0) - "A".charCodeAt(0);

        let cols = []

        headerConfigs.forEach(i => {

            let colName = i?.colName
            let width = i?.width

            let index = getColumnIndex(colName)

            cols[index] = { wch: width }

        })

        return cols
    }

    const buildBodyHeader = ({ headerNames = [] }) => {
        return [headerNames]
    }

    const buildBodySection = ({
        headerKeys,
        rows,
    }) => {

        let data = []

        rows.forEach((i1, index1) => {

            let row = []

            headerKeys.forEach(col => {
                row.push(
                    i1[col]
                )
            })

            data.push(row)

            // let row = i1

            // let itemData = Object.keys(row).map(i2 => row[i2])

            // // console.log('itemData', itemData)

            // data.push(itemData)

        })

        return data
    }

    // Function to set an entire column as a data type
    const setCellsDataTypes = ({ ws, fromRowNo, toRowNo, cols }) => {

        for (let i = fromRowNo; i < toRowNo; i += 1) {

            cols.forEach(i2 => {

                let cell = `${i2?.colName}${i}`

                // console.log('change', cell, 'to ', i2?.dataType)

                ws[cell].t = i2?.dataType

            })

        }

    };

    // for export excel
    const generateExcel = async ({
        data,
        headerKeys,
        headerConfigs,
        config = {
            generateFileName: ''
        }
    }) => {

        // console.log('headerConfigs', headerConfigs)

        let rawLines = []

        // let headerNames = headerKeys
        // let rawLinesHeader = buildTopSection({ data: container, items })
        let rawLinesBodyHeader = buildBodyHeader({ headerNames: headerKeys })
        let rawLinesBody = buildBodySection({
            headerKeys,
            rows: data
        })

        // rawLines = [...rawLines, ...rawLinesHeader]
        // rawLines = [...rawLines, []] // break one line
        rawLines = [...rawLines, ...rawLinesBodyHeader]
        rawLines = [...rawLines, ...rawLinesBody]

        // let mergesHeader = getTopSectionMerges()
        // let mergesBody = getBodySectionMerges({
        //     offsetRowCount: rawLinesHeader.length,
        //     inputProducts: items,
        //     // dataProducts,
        //     // dataItems
        // })

        // merges = [...merges, ...mergesHeader, ...mergesBody]
        // merges = [...merges, ...mergesHeader]

        // if (isSimpleMode === false) {
        //     merges = [...merges, ...mergesBody]
        // }

        /* create worksheet */
        let ws = XLSX.utils.aoa_to_sheet(rawLines);
        /* create workbook and export */
        let wb = XLSX.utils.book_new();

        // ws["!merges"] = merges
        ws["!cols"] = getColsDefault({ headerConfigs })

        let fromRowNo = (rawLinesBodyHeader.length) + 1
        let toRowNo = fromRowNo + rawLinesBody.length

        // console.log('fromRowNo', fromRowNo, 'to', toRowNo)

        setCellsDataTypes({
            ws,
            fromRowNo,
            toRowNo,
            cols: headerConfigs
        })

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, `${config?.generateFileName}`);

        return {
            payload: {
                fileName: config?.generateFileName
            }
        }

    }

    return {
        generateExcel
    }

}